import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.21.8_@netlify+blobs@9.1.2_@parcel+watcher@2.5.6_@types+node@25.2.3_@upstash+redi_01ef9c286f543dd8bd2f965aa464f458/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/vercel/path0/apps/eb-builder/middleware/auth.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.21.8_@netlify+blobs@9.1.2_@parcel+watcher@2.5.6_@types+node@25.2.3_@upstash+redi_01ef9c286f543dd8bd2f965aa464f458/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "clean-query": () => import("/vercel/path0/apps/eb-builder/middleware/clean-query.ts")
}